import { useMemo } from "react";
import { NativeSelect } from "@altimateai/lego";
import { useWorkspaces } from "@/pages/workspaces/hooks";
import { useSelectedWorkspaceParam } from "../hooks";

const ALL_WORKSPACES_VALUE = "all";

const DatabricksWorkspaceSelector = () => {
  const [selectedWorkspace, setSelectedWorkspace] = useSelectedWorkspaceParam();
  const { data: workspacesData, isLoading } = useWorkspaces(true);

  const options = useMemo(
    () => [
      { label: "All", value: ALL_WORKSPACES_VALUE },
      ...(workspacesData?.workspaces ?? []).map(ws => ({
        label: ws.workspace_name || ws.workspace_id,
        value: ws.workspace_id,
      })),
    ],
    [workspacesData]
  );

  if (isLoading || !workspacesData?.workspaces?.length) {
    return null;
  }

  return (
    <NativeSelect
      label="Workspace:"
      showPlaceholder
      variant="outline"
      size="sm"
      value={selectedWorkspace || ALL_WORKSPACES_VALUE}
      options={options}
      onChange={value => setSelectedWorkspace(value === ALL_WORKSPACES_VALUE ? "" : value)}
      buttonProps={{
        "aria-label": "Workspace filter",
        className: "!al-bg-white",
      }}
    />
  );
};

export default DatabricksWorkspaceSelector;
